var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterFullScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.286 14.286H4V20h5.714v-2.286H6.286v-3.428zM4 9.714h2.286V6.286h3.428V4H4v5.714zm13.714 8h-3.428V20H20v-5.714h-2.286v3.428zM14.286 4v2.286h3.428v3.428H20V4h-5.714z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
export default SvgEnterFullScreen;